/* CYRA product page behaviour.
   Extracted verbatim from sections/product-main.liquid on 30 Aug 2026. The only change is
   that the two Liquid-interpolated values (the variant array and the single-variant flag)
   now come from window.CYRA_PRODUCT, which the section sets in a small inline bootstrap
   immediately before loading this file. Everything else is byte-identical logic.
   Loaded with defer, so it runs once, after the markup is parsed and before
   DOMContentLoaded listeners fire. */
function cyraSwitchImage(thumb){
  var mainImg=document.getElementById('cyra-main-img');
  mainImg.classList.add('cyra-fade');
  setTimeout(function(){
    mainImg.src=thumb.dataset.src;
    mainImg.alt=thumb.dataset.alt;
    // Square infographics must never be cropped by the 3:4 frame.
    mainImg.style.objectFit=thumb.dataset.fit||'cover';
    // Paint the frame behind a contained image to match the artwork's own backdrop,
    // so the leftover strip reads as part of the card rather than as a letterbox.
    var wrap=document.getElementById('cyra-main-img-wrap');
    if(wrap) wrap.style.background=thumb.dataset.bg||'';
    mainImg.classList.remove('cyra-fade');
  },150);
  document.querySelectorAll('.cyra-thumb').forEach(function(t){t.classList.remove('active');});
  thumb.classList.add('active');
}
function cyraFilterByColor(color){
  var thumbs=document.querySelectorAll('.cyra-thumb');
  var firstVisible=null;
  var hasColorImages=false;
  thumbs.forEach(function(t){
    if(t.dataset.color && t.dataset.color.indexOf(color)!==-1) hasColorImages=true;
  });
  thumbs.forEach(function(t){
    t.classList.remove('active');
    if(!hasColorImages){
      t.classList.remove('cyra-hidden');
      if(!firstVisible) firstVisible=t;
    } else {
      if(t.dataset.color && t.dataset.color.indexOf(color)!==-1){
        t.classList.remove('cyra-hidden');
        if(!firstVisible) firstVisible=t;
      } else {
        t.classList.add('cyra-hidden');
      }
    }
  });
  if(firstVisible) cyraSwitchImage(firstVisible);
}
function cyraToggleAcc(btn){
  var item=btn.closest('.cyra-acc');
  var isOpen=item.classList.contains('open');
  document.querySelectorAll('.cyra-acc.open').forEach(function(i){
    i.classList.remove('open');
    var t=i.querySelector('.cyra-acc__trigger');
    if(t) t.setAttribute('aria-expanded','false');
  });
  if(!isOpen){ item.classList.add('open'); btn.setAttribute('aria-expanded','true'); }
}
function cyraQty(delta){var input=document.getElementById('cyra-qty-input');input.value=Math.max(1,parseInt(input.value)+delta);}
var cyraSizeOpener=null;
function cyraOpenSizeChart(){
  var modal=document.getElementById('cyra-size-modal');
  if(!modal) return;
  cyraSizeOpener=document.activeElement;
  modal.classList.add('open');
  modal.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  var drawer=modal.querySelector('.cyra-size-modal__drawer');
  if(drawer) drawer.focus();
}
function cyraCloseSizeChart(){
  var modal=document.getElementById('cyra-size-modal');
  if(!modal) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
  if(cyraSizeOpener && cyraSizeOpener.focus) cyraSizeOpener.focus();
}
document.addEventListener('keydown',function(e){
  if(e.key==='Escape') cyraCloseSizeChart();
  if(e.key==='Tab'){
    var modal=document.getElementById('cyra-size-modal');
    if(!modal || !modal.classList.contains('open')) return;
    var f=modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }
});
document.addEventListener('DOMContentLoaded',function(){
  var firstColorInput=document.querySelector('.cyra-swatches input[type="radio"]:checked');
  if(firstColorInput && firstColorInput.dataset.color) cyraFilterByColor(firstColorInput.dataset.color);
});

(function(){var stickyBar=document.getElementById('cyra-sticky-atc');var atcBtn=document.getElementById('cyra-atc-btn');if(!stickyBar||!atcBtn)return;new IntersectionObserver(function(entries){entries.forEach(function(e){stickyBar.classList.toggle('visible',!e.isIntersecting);});},{threshold:0}).observe(atcBtn);})();

(function(){
  // Supplied by the inline bootstrap in sections/product-main.liquid.
  var variants=(window.CYRA_PRODUCT&&window.CYRA_PRODUCT.variants)||[];
  var form=document.getElementById('cyra-product-form');
  if(!form) return;
  var hiddenId=document.getElementById('cyra-variant-id');
  var atcBtn=document.getElementById('cyra-atc-btn');
  var msgEl=document.getElementById('cyra-atc-msg');
  var singleVariant=!!(window.CYRA_PRODUCT&&window.CYRA_PRODUCT.singleVariant);

  function stickyBtn(){return document.querySelector('.cyra-sticky-atc__btn');}
  function money(cents){
    var S = window.MinimogSettings || {};
    var fmt = S.money_with_currency_format || S.money_format || '${{amount}}';
    var amt = (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/, amt);
  }

  function radios(){return Array.prototype.slice.call(form.querySelectorAll('input[type="radio"][data-opt-index]'));}

  // Selected option values, indexed by the product's own option position.
  // An option the customer has not chosen yet stays null - it is never guessed.
  function getSelected(){
    var sel=[];
    var n=0;
    radios().forEach(function(r){
      var i=parseInt(r.dataset.optIndex,10);
      if(i+1>n) n=i+1;
      if(r.checked) sel[i]=r.value;
    });
    for(var j=0;j<n;j++){ if(sel[j]===undefined) sel[j]=null; }
    return sel;
  }

  function missing(sel){var c=0;for(var i=0;i<sel.length;i++){if(sel[i]===null)c++;}return c;}

  // The one variant matching every selected option exactly. Never a fallback.
  function exactVariant(sel){
    if(!sel.length) return variants.length===1?variants[0]:null;
    if(missing(sel)) return null;
    var found=null;
    variants.forEach(function(v){
      if(found) return;
      var ok=true;
      for(var i=0;i<sel.length;i++){ if(v.options[i]!==sel[i]){ ok=false; break; } }
      if(ok) found=v;
    });
    return found;
  }

  // Is any available variant reachable if option i were set to `value`,
  // holding every other currently selected option fixed?
  function reachable(i,value,sel){
    for(var n=0;n<variants.length;n++){
      var v=variants[n];
      if(v.options[i]!==value) continue;
      if(!v.available) continue;
      var ok=true;
      for(var j=0;j<sel.length;j++){
        if(j===i) continue;
        if(sel[j]!==null && v.options[j]!==sel[j]){ ok=false; break; }
      }
      if(ok) return true;
    }
    return false;
  }

  function setMediaFor(v){
    if(!v||!v.featured_image||!v.featured_image.src) return;
    var name=String(v.featured_image.src).split('?')[0].split('/').pop();
    if(!name) return;
    var thumbs=document.querySelectorAll('.cyra-thumb');
    for(var i=0;i<thumbs.length;i++){
      var src=thumbs[i].dataset.src||'';
      if(src.split('?')[0].split('/').pop()===name){
        if(typeof cyraSwitchImage==='function') cyraSwitchImage(thumbs[i]);
        return;
      }
    }
  }

  function setMsg(text,alert){
    if(!msgEl) return;
    msgEl.textContent=text||'';
    if(alert) msgEl.classList.add('is-alert'); else msgEl.classList.remove('is-alert');
  }
  window.cyraSizePrompt=function(){
    setMsg('Please select a size before adding to your bag.',true);
    var first=form.querySelector('input[type="radio"][data-opt-kind="size"]:not(:disabled)');
    if(first&&first.focus) first.focus();
  };

  function setBuyState(v,sel){
    var incomplete=sel.length>0&&missing(sel)>0;
    var sellable=!!(v&&v.available);
    // An unresolved, incomplete or unavailable selection must never carry a submittable id.
    if(hiddenId) hiddenId.value=sellable?v.id:'';
    var label,sticky;
    if(sellable){ label='Add to Bag — <span id="cyra-atc-price">'+money(v.price)+'</span>'; sticky='Add to Bag'; }
    else if(incomplete){ label='Select a size'; sticky='Select a size'; }
    else if(v){ label='Sold Out'; sticky='Sold Out'; }
    else { label='Unavailable in this combination'; sticky='Unavailable'; }
    if(atcBtn){
      atcBtn.disabled=!sellable;
      atcBtn.setAttribute('aria-disabled',sellable?'false':'true');
      atcBtn.innerHTML=label;
    }
    var sb=stickyBtn();
    if(sb){
      sb.disabled=!sellable;
      sb.setAttribute('aria-disabled',sellable?'false':'true');
      sb.textContent=sticky;
    }
    var sp=document.querySelector('.cyra-sticky-atc__price');
    if(sp&&sellable) sp.textContent=money(v.price);
    if(sellable) setMediaFor(v);
    if(incomplete) setMsg('Choose a size to continue.',false);
    else if(!v&&sel.length) setMsg('That combination is not available. Try another size or colour.',false);
    else setMsg('',false);
  }

  function refresh(){
    var sel=getSelected();
    radios().forEach(function(r){
      var i=parseInt(r.dataset.optIndex,10);
      var ok=reachable(i,r.value,sel);
      r.disabled=!ok;
      r.setAttribute('aria-disabled',ok?'false':'true');
      var lab=r.closest('label');
      if(lab) lab.classList.toggle('cyra-unavailable',!ok);
    });
    setBuyState(exactVariant(sel),sel);
  }

  // No size is ever preselected. Clears anything the browser restored on refresh.
  function clearSizes(){
    radios().forEach(function(r){ if(r.dataset.optKind!=='color') r.checked=false; });
  }

  // The ONLY automatic size selection: an explicit, valid ?variant= in the URL.
  function applyVariantParam(){
    var m=/[?&]variant=(\d+)/.exec(window.location.search);
    if(!m) return false;
    var want=null;
    for(var i=0;i<variants.length;i++){ if(String(variants[i].id)===m[1]){ want=variants[i]; break; } }
    if(!want) return false;
    radios().forEach(function(r){
      var idx=parseInt(r.dataset.optIndex,10);
      r.disabled=false;
      r.checked=(want.options[idx]===r.value);
    });
    return true;
  }

  function init(){
    if(!singleVariant){ clearSizes(); applyVariantParam(); }
    refresh();
  }

  form.querySelectorAll('input[type="radio"]').forEach(function(r){r.addEventListener('change',refresh);});
  window.cyraRefreshVariant=refresh;
  init();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  // bfcache restore: recompute from the DOM so no stale id can survive Back/Forward.
  window.addEventListener('pageshow',function(e){ if(e.persisted) refresh(); });
})();

function cyraShowCartNotification(){
  var notif=document.getElementById('cyra-cart-notification');
  var countEl=document.getElementById('cyra-cart-count');
  // The toast is optional. The cart-count refresh below is not, so it must not
  // be skipped just because this template has no notification element.
  if(notif) notif.classList.add('visible');
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
    if(countEl){
      countEl.textContent=c.item_count;
      countEl.classList.toggle('hidden', c.item_count===0);
    }
    document.querySelectorAll('.cart-count').forEach(function(el){el.textContent='('+c.item_count+')';});
    // The CYRA header renders in its own section, so its cart badge is not
    // reachable from here. Hand the already-fetched count to the header's
    // painter rather than issuing a second /cart.js request.
    if(typeof window.cyraSyncCartCount==='function') window.cyraSyncCartCount(c.item_count);
  });
  if(notif) setTimeout(function(){notif.classList.remove('visible');},4000);
}

function cyraAddToCart(){
  var btn=document.getElementById('cyra-atc-btn');
  var stickyBtn=document.querySelector('.cyra-sticky-atc__btn');
  var idEl=document.getElementById('cyra-variant-id');
  var id=idEl?idEl.value:'';
  // Refuse to submit when the selection resolves to no variant.
  if(!id||(btn&&btn.disabled)){
    if(typeof window.cyraSizePrompt==='function') window.cyraSizePrompt();
    return;
  }
  var original=btn ? btn.innerHTML : '';
  if(btn){btn.innerHTML='Adding...';btn.disabled=true;}
  if(stickyBtn){stickyBtn.textContent='Adding...';stickyBtn.disabled=true;}
  var qty=parseInt(document.getElementById('cyra-qty-input').value)||1;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty})})
  .then(function(r){return r.json();})
  .then(function(){
    if(btn){btn.innerHTML='Added ✓';}
    if(stickyBtn){stickyBtn.textContent='Added ✓';}
    cyraShowCartNotification();
    setTimeout(function(){
      if(typeof window.cyraRefreshVariant==='function'){window.cyraRefreshVariant();}
      else{if(btn){btn.innerHTML=original;btn.disabled=false;}if(stickyBtn){stickyBtn.textContent='Add to Bag';stickyBtn.disabled=false;}}
    },2000);
  }).catch(function(){
    if(typeof window.cyraRefreshVariant==='function'){window.cyraRefreshVariant();}
    else{if(btn){btn.innerHTML=original;btn.disabled=false;}if(stickyBtn){stickyBtn.textContent='Add to Bag';stickyBtn.disabled=false;}}
  });
}

document.getElementById('cyra-product-form').addEventListener('submit',function(e){
  e.preventDefault();
  cyraAddToCart();
});